import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {CatalogueService} from "../catalogue/catalogue.service";

@Component({
  selector: 'app-modal-simple',
  templateUrl: './modal-simple.component.html',
  styleUrls: ['./modal-simple.component.css']
})

export class ModalSimpleComponent implements OnInit {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  @Input() modalInformation;
  @Input() titleTranslation;
  @Input() isHtml:boolean = true;

  constructor(private ngbActiveModal: NgbActiveModal,
              public catalogueService: CatalogueService) { }

  close(){
    this.ngbActiveModal.dismiss();
  };

  ngOnInit() {
  }

}
